import { useId } from 'react';
import { FormField } from './FormField';
import { Textarea } from './Textarea';

/**
 * Mandatory audit reason (FE plan §3.7). Every money/tax lever write carries
 * one (BE reqs §7.6 LeverAuditLog), as do point adjustments and payouts. The
 * caller keeps its submit disabled until `isReasonValid(value)`.
 */
export const MIN_REASON_LENGTH = 3;

export function isReasonValid(value: string | undefined | null): boolean {
  return (value ?? '').trim().length >= MIN_REASON_LENGTH;
}

export function ReasonField({
  value,
  onChange,
  label = 'Reason for change',
  hint = 'Logged permanently with who made the change and when.',
  error,
}: {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  hint?: string;
  error?: string;
}) {
  const id = useId();
  return (
    <FormField label={label} htmlFor={id} required hint={hint} error={error}>
      <Textarea
        id={id}
        rows={2}
        maxLength={500}
        value={value}
        invalid={!!error}
        onChange={(e) => onChange(e.target.value)}
      />
    </FormField>
  );
}
